import Panic from './Panic';
import store from './store';

export default new class {
	decode_arguments(argv) {
		var path;
		var vars;
		var callback;
		for (var i = 0; i < argv.length; i++) {
			var arg = argv[i];
			var type = typeof arg;
			switch (type) {
			case "string":
				if (path !== undefined) Panic("more than one 'path' argument");
				path = arg;
				break
			case "object":
				if (vars !== undefined) Panic("more than one 'vars' argument");
				vars = arg;
				break;
			case "function":
				if (callback !== undefined) Panic("more than one 'callback' argument");
				callback = arg;
				break;
			default:
				Panic("unexpected arg type " + type + " at index " + i);
				break;
			}
		}
		if (path === undefined) Panic("called without 'path' argument");
		return {path,vars,callback};
	}

	calculate_ttl(xhr) {
		const cc = xhr.getResponseHeader("Cache-Control");
		if (!cc) return undefined;

		const cc_mo = cc.match(/max-age\s*=\s*(\d+)/);
		if (!cc_mo) return undefined;

		const max_age = parseInt(cc_mo[1], 10);

		/* CloudFront provides an Age header */
		const age_str = xhr.getResponseHeader("Age");
		var age;
		if (age_str) {
			age = parseInt(age_str, 10);
		} else {
			/* Reaching this point means that a Cache-Control
			 * header is present, but an Age header is not. This,
			 * in turn, indicates that we're running in
			 * development, because CloudFront always adds an Age
			 * header if a Cache-Control header is present (and
			 * conversely, never adds a Cache-Control header for
			 * uncachable documents). So: XXX the following code is
			 * a fallback based on the Date header, and should not
			 * be used in production (it makes some assumptions
			 * about the format, and is not fully RFC-7234
			 * compliant) */
			 const date_mo = xhr.getResponseHeader("Date").match(/\S+, (\d+) (\S+) (\d+) (\d+):(\d+):(\d+)/);
			 const year = parseInt(date_mo[3], 10);
			 const month_index = {Jan:0, Feb:1, Mar:2, Apr:3, May:4, Jun:5, Jul:6, Aug:7, Sep:8, Oct:9, Nov:10, Dec:11}[date_mo[2]];
			 const day = parseInt(date_mo[1],  10);
			 const hours = parseInt(date_mo[4], 10);
			 const minutes = parseInt(date_mo[5], 10);
			 const seconds = parseInt(date_mo[6], 10);
			 age = (Date.now() - Date.UTC(year, month_index, day, hours, minutes, seconds)) / 1000;
		}

		return max_age - age;
	}

	request(method, argv) {
		var {path, vars, callback} = this.decode_arguments(argv);

		var xhr = new XMLHttpRequest();
		xhr.withCredentials = true;
		xhr.responseType = "text";
		xhr.onreadystatechange = () => {
			if (xhr.readyState !== 4) return;
			var response;
			try {
				response = JSON.parse(xhr.response);
			} catch (e) {
				response = xhr.response;
			}
			if (Math.floor(xhr.status / 100) === 5) {
				store.trigger_fatal_error();
			} else {
				if (callback) callback(response, xhr.status, this.calculate_ttl(xhr));
			}
		};

		const is_bodyless = method === "GET" || method === "HEAD";

		const query = (() => {
			if (!vars) return null;
			var q = "";
			var delim = "";
			for (var k in vars) {
				if (vars[k] === undefined) continue;
				var v = vars[k];
				if (typeof v === "object") v = JSON.stringify(v);
				q += delim + k + "=" + encodeURIComponent(v);
				delim = "&";
			}
			return q;
		})();

		if (is_bodyless && query) {
			path += "?" + query;
		}

		xhr.open(method, path);
		if (!is_bodyless && vars) {
			xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
			xhr.send(query);
		} else {
			xhr.send();
		}

		return xhr;
	}

	get() {
		return this.request("GET", arguments);
	}

	post() {
		return this.request("POST", arguments);
	}

	log(msg) {
		if (typeof msg === "object") msg = JSON.stringify(msg);
		this.post("/z/log", {msg});
	}
}();



// WEBPACK FOOTER //
// ./src/API.js